import { canUseDOM } from "history/DOMUtils";
import type { PostFetchFnType } from "../../../../common-deprecated/utils/registryTypes";
import type { CarConfigStateType, CarConfigStoreType } from "../redux/store";
import { calculatePrice, initBasket } from "../redux/slices/CarConfigBasketSlice";
import { maximizeBasket } from "../../../shared-logic/utils/basketUtils";
import type { FinanceOptionType } from "../../../../common-deprecated/types/CommonTypes";
import { setFinanceOption } from "../../../../common-deprecated/redux/actions/UtilActions";
import Debug from "../../../../common-deprecated/Debug";
import { overrideCarConfigSettings } from "../redux/slices/CarConfigSettingsSlice";
import { setFinanceProductType } from "../redux/slices/CarConfigFinanceSlice";
import { setActiveSection } from "../redux/slices/CarConfigNavigationSlice";
import { showCarConfigMonthlyRate } from "../utils/financeInsuranceRate";
import { promoteAemMonthlyRates } from "../../../../common-deprecated/settings/utils/financeSettingUtilsAem";
import { AemFmComponent } from "../../../../common-deprecated/utils/aemFlexibilityMatrixUtils";

export const carConfigPostFetch: PostFetchFnType<CarConfigStoreType> = (store) => {
    const { dispatch, getState } = store;
    const { basket, car, items, commonSettings, save, utils, finance, carConfigSettings, carConfigNavigation } =
        getState();
    const { requireFinanceQuoteToDisplayFinanceData } = carConfigSettings;
    const injectionBody = commonSettings.body as Partial<{ reduxState: Partial<CarConfigStateType> }>;

    const showMonthlyRates = showCarConfigMonthlyRate(commonSettings, car);
    const promoteMonthlyFinance = promoteAemMonthlyRates(
        commonSettings,
        AemFmComponent.Carconfig,
        "new",
        car?.model.internalCode,
    );

    if (!canUseDOM) {
        let financeOption: FinanceOptionType = promoteMonthlyFinance ? "monthly" : "cash";
        if (showMonthlyRates)
            financeOption =
                commonSettings.query.financeOption || save.data?.Personal?.Parameters.FinanceOption || financeOption;

        if (financeOption !== utils.financeOption) {
            if (
                (requireFinanceQuoteToDisplayFinanceData && finance.quotes.finance) ||
                !requireFinanceQuoteToDisplayFinanceData
            ) {
                dispatch(setFinanceOption(financeOption));
            }
        }
    }

    dispatch(initBasket(maximizeBasket(car, items, basket, carConfigNavigation.basketParams)));

    const { financeProductType } = commonSettings.query;

    if (financeProductType) dispatch(setFinanceProductType({ financeProduct: financeProductType }));

    dispatch(calculatePrice({}));

    // check for a reduxState in the post body and override carconfigSettings if set.
    const carConfigSettingsFromBody = injectionBody.reduxState?.carConfigSettings;
    if (carConfigSettingsFromBody) {
        Debug.info(
            "[CarConfigPostFetch] Added URLs of different steps using injection post BODY overrides",
            carConfigSettingsFromBody.loadedStepUrls,
        );

        dispatch(overrideCarConfigSettings({ loadedStepUrls: carConfigSettingsFromBody.loadedStepUrls }));
    }

    // Mainly for retailerscreen, but didn't see the harm in allowing this everywhere
    // Instead of using the location.hash, this queryparam allows you to SSR a specific section (to improve performance)
    if (commonSettings.query.ccSection && !canUseDOM) {
        dispatch(setActiveSection(commonSettings.query.ccSection));
    }

    return { addCacheHeaders: true };
};
